var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.options?.length
    ? _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.item.value,
              expression: "item.value",
            },
          ],
          staticClass: "form-select form-select-sm d-inline-block w-auto",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.item,
                "value",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        [
          _c(
            "option",
            { attrs: { selected: "", disabled: "", value: "null" } },
            [_vm._v("Select…")]
          ),
          _vm._v(" "),
          _vm._l(_setup.options, function (option) {
            return _c(
              "option",
              { key: option.value, domProps: { value: option.value } },
              [_vm._v("\n        " + _vm._s(option.text) + "\n    ")]
            )
          }),
        ],
        2
      )
    : _setup.options?.length === 0
    ? _c("small", { staticClass: "form-text ms-2 mb-1 fst-italic small" }, [
        _vm._v("\n    No options available\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }